module.exports = __webpack_public_path__ + "static/media/map-direction.5c4e5b7c.png";